import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './AppBanner.scss'

import { InlineShell } from 'components/Shells'

const AppBanner = ({ app: { name, iconUrl, status } }) => {
	return (
		<div styleName="section">
			<div styleName="container">
				{iconUrl
					? <img src={iconUrl} styleName="icon" alt={name} />
					: <div styleName="icon-placeholder" />}
				<div styleName="name">
					{name || <InlineShell width={100} />}
				</div>
			</div>
		</div>
	)
}

AppBanner.propTypes = {
	path: React.PropTypes.string,
	name: React.PropTypes.string
}

export default CSSModules(AppBanner, styles)



// WEBPACK FOOTER //
// ./src/components/Navigation/AppBanner.js